<template>
  <div class="domino-sum-banker-odd-even">
    <Row type="flex">
      <Col id="domino-history-odd" class="domino-history-bar">
        {{ $t("general.Odd") }}
        <span>{{ this.o_percentage }}%</span>
      </Col>
      <Col id="domino-history-even" class="domino-history-bar">
        {{ $t("general.Even") }}
        <span>{{ this.e_percentage }}%</span>
      </Col>
    </Row>
    <Row v-if="this.newArr" type="flex" justify="space-around">
      <Col
        class="domino-history-trend-lot-col"
        v-for="(col, index) in this.newArr"
        :key="index"
      >
        <div
          class="domino-history-trend-lot-cell"
          :class="getPBClass(cell[8])"
          v-for="(cell, index) in col"
          :key="index"
        >
          <domino-history-popper
            :game="game"
            :table-name="tableName"
            :cell-data="cell"
            :game-code="gameCode"
            :game-id="gameId"
            >{{ getPBCell(cell[8]) }}</domino-history-popper
          >
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import DominoHistoryPopper from "../widgets/DominoHistoryPopper";
import { TimelineMax } from "gsap";

export default {
  props: ["historicalData", "game", "gameCode", "gameId", "tableName"],
  components: {
    Row,
    Col,
    DominoHistoryPopper,
  },
  data() {
    return {
      tempArr: [],
      newArr: [],
      totalRow: 18,
      o_percentage: 0,
      e_percentage: 0,
      previousBadgeCount: 0,
    };
  },
  methods: {
    getPBClass(value) {
      if (value == 10) return "odd";
      if (value == 11) return "even";
    },
    getPBCell(value) {
      if (value == 10) return this.$t("domino.o10_trend");
      if (value == 11) return this.$t("domino.o11_trend");
    },
    triggerBlinkingEffect() {
      this.$nextTick(() => {
        let animationTl = new TimelineMax();

        animationTl
          .to(
            "#game-" +
              this.gameId +
              " .domino-history-trend-lot-col:last-of-type .domino-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 0,
            }
          )
          .to(
            "#game-" +
              this.gameId +
              " .domino-history-trend-lot-col:last-of-type .domino-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 1,
            }
          );
        animationTl.repeat(4);
      });
    },
  },
  watch: {
    historicalData() {
      this.tempArr = [];
      let tempData = [...this.historicalData];
      let index = 0;
      this.o_percentage = 0;
      this.e_percentage = 0;

      for (var i = 0; i < tempData.length; i++) {
        let temp = [];

        if (tempData[i]["sboe"] == 10) this.o_percentage++;
        if (tempData[i]["sboe"] == 11) this.e_percentage++;

        temp.push(tempData[i]["pb"]);
        temp.push(tempData[i]["p1_result"], tempData[i]["p2_result"]);
        temp.push(tempData[i]["b1_result"], tempData[i]["b2_result"]);
        temp.push(tempData[i]["spbs"], tempData[i]["spoe"]);
        temp.push(tempData[i]["sbbs"], tempData[i]["sboe"]);
        temp.push(tempData[i]["draw_no"], tempData[i]["draw_datetime"]);
        temp.push(tempData[i]["p_sum"], tempData[i]["b_sum"]);
        this.tempArr.push(temp);
      }
      this.tempArr.reverse();

      (index = 8),
        (this.newArr = this.tempArr.reduce((result, data, i, array) => {
          if (
            !array[i - 1] ||
            data[index] !== array[i - 1][index] ||
            result[result.length - 1].length === 5
          )
            result.push([]);
          result[result.length - 1].push(data);
          return result;
        }, []));

      this.newArr.reverse();
      this.newArr.splice(this.totalRow);
      this.newArr.reverse();
      this.triggerBlinkingEffect();

      let emitArr = ["b_oe", "domino.B_OE"];
      let tempValue = 0;

      if (
        this.newArr[this.totalRow - 1][0][8] ==
          this.newArr[this.totalRow - 3][0][8] &&
        this.newArr[this.totalRow - 1][0][8] ==
          this.newArr[this.totalRow - 2][0][8]
      ) {
        tempValue =
          this.newArr[this.totalRow - 1].length +
          this.newArr[this.totalRow - 2].length +
          this.newArr[this.totalRow - 3].length;
      } else if (
        this.newArr[this.totalRow - 1][0][8] ==
        this.newArr[this.totalRow - 2][0][8]
      ) {
        tempValue =
          this.newArr[this.totalRow - 1].length +
          this.newArr[this.totalRow - 2].length;
      } else {
        tempValue = this.newArr[this.totalRow - 1].length;
      }

      if (tempValue > 3) emitArr.push(tempValue);
      else {
        emitArr.push(0);
        tempValue = 0;
      }

      emitArr.push(this.newArr[this.totalRow - 1][0][8]);

      if (this.newArr[this.totalRow - 1][0][8] == 10) {
        emitArr.push("goodRoadIconGrey");
      } else {
        emitArr.push("goodRoadIconYellow");
      }

      if (this.previousBadgeCount != tempValue) {
        this.$emit("get-badge-count", emitArr);
      }

      this.previousBadgeCount = tempValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.domino-history-trend-lot-cell {
  color: #ffffff;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  border-radius: 100px;
  margin-top: 6px;
  cursor: pointer;
  overflow: hidden;
}

.domino-history-trend-lot-cell.odd {
  background: $domino-trend-lot-color-4;
}

.domino-history-trend-lot-cell.even {
  background: $domino-trend-lot-color-3;
  color: white;
}
</style>